import { Link } from "react-router-dom";

function MainComponent() {

    document.title = "ご利用にあたって| ファーストコンタクトセンター";
    const imageUrl = require("../../images/popup.png");
    return (
        <>
            <div className="header-utility">
                <div className="header-utility-inner">
                    <ul className="header-utility-list sub">
                    </ul>
                </div>
            </div>
            <main className="site-main">
                <section className="sct-primary">
                    <div className="str-outer-wide">
                        <div className="str-inner">
                            <div className="mod-hdg-l1">
                                <div className="inner">
                                    <h1 className="hdg">Web問い合わせシステム</h1>
                                    <span className="sub of-top">NEC ファーストコンタクトセンター</span>
                                </div>
                            </div>
                            <h2 className="mod-hdg-l2-02">
                                <span>ご利用にあたって</span>
                            </h2>

                            <h3 className="mod-hdg-l3-02">
                                <span>対象製品</span>
                            </h3>

                            <div className="mod-txt">
                                <p>NEC ファーストコンタクトセンター(以下、「当センター」)は、当センターが運営するWeb問い合わせシステム(以下、「当システム」)を使用して、以下製品のお問い合わせに対応いたします。</p>
                            </div>

                            <div className="mod-list">
                                <ul className="list">
                                    <li>
                                        <div className="mod-txt">
                                            <p>ビジネスPC(Mate，VersaPro，Chromebook)</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="mod-txt">
                                            <p>Express5800シリーズ</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="mod-txt">
                                            <p>iStorageシリーズ</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="mod-txt">
                                            <p>Express5800シリーズ(UL/UW型番)/iStorageシリーズ(UF型番)用ソフトウェア</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>

                            <div className="mod-list-02 of-notice">
                                <ul className="list">
                                    <li>
                                        <span className="mark"><em>※</em></span>
                                        <div className="content">
                                            <div className="mod-txt">
                                                <p><em><img src={imageUrl} alt="popup" className="icn" lang="en" />
                                                    <a href="https://jpn.nec.com/press/202410/20241017_01.html" target="_blank">法人顧客向けNECブランドPCの販売機能移管 </a>
                                                    に伴い、2025年4月1日より当センターはNECパーソナルコンピュータ株式会社と共同で運用し、ビジネスPC製品のお問い合わせはNECパーソナルコンピュータ株式会社が対応いたします。</em></p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>

                            <h3 className="mod-hdg-l3-02">
                                <span>サービス対象者</span>
                            </h3>

                            <div className="mod-txt">
                                <p>当システムの登録及び利用は、NEC販売特約店様、NEC販売提携店様、プラットフォームパートナー様、オープンパートナー様、得選街パートナー様、NEC社内、NECグループ会社の方を対象とさせて頂きます。</p>
                            </div>

                            <h3 className="mod-hdg-l3-02">
                                <span>サービス内容</span>
                            </h3>

                            <div className="mod-txt">
                                <p>当システムにご登録いただいたサービス対象者に対して、以下のサービスを提供いたします。</p>
                            </div>

                            <div className="mod-list">
                                <ul className="list">
                                    <li>
                                        <div className="mod-txt">
                                            <p>サービス対象製品に関するお問い合わせ・ご相談をWeb登録により承り、電子メールにて回答いたします。</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="mod-txt">
                                            <p>お問い合わせ頂く際には、Partner's Bridge（販売店様・パートナー様）またはDWP（NECグループの方）へのログインが必要です。</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="mod-txt">
                                            <p>希望者に対して、対象製品（ビジネスPCを除く）に関する情報を電子メールにて配信いたします。</p>
                                            <p>配信設定は既定で「配信する」になっています。配信を希望されない場合は、「利用者情報変更」よりFCCニュースを「配信しない」に変更してください。</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="mod-txt">
                                            <p>製品やサービスに対するご意見やご要望をアンケートにてお伺いする場合があります。</p>
                                        </div>
                                    </li>
                                    <li>
                                    </li>
                                </ul>
                            </div>
                            <div className="mod-list-02 of-notice">
                                <ul className="list">
                                    <li>
                                        <span className="mark"><em>※</em></span>
                                        <div className="content">
                                            <div className="mod-txt">
                                                <p><em> 上記サービスのご利用において、当センターが知り得た各種情報は厳重にお取り扱いいたします。</em></p>
                                                <p><em>
                                                    個人情報の取扱いについては<img src={imageUrl} alt="popup" className="icn" lang="en" /><Link
                                                        to="/handle_personal_info" target="_blank">「NEC ファーストコンタクトセンターにおける個人情報の取扱いについて」</Link>をご確認ください。
                                                </em></p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <span className="mark"><em>※</em></span>
                                        <div className="content">
                                            <div className="mod-txt">
                                                <p><em> お問い合わせいただく前に <img src={imageUrl} alt="popup" className="icn" lang="en" /><Link
                                                    to="/about_contact_service" target="_blank">「NEC ファーストコンタクトセンターのサービス内容詳細」</Link>
                                                    も併せてご一読ください。</em></p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>

                            <h3 className="mod-hdg-l3-02">
                                <span>サービス運営の変更・停止について</span>
                            </h3>

                            <div className="mod-txt">
                                <p>当システムでは、登録者へ事前通知なく、本サービスのユーザインタフェースまたはシステムを変更することができるものとします。</p>
                                <p>
                                    当システムでは、保守作業、システム復旧、停電や天災などの不可抗力、またはその他やむを得ない理由により、本サービスの運営を中止または中断する場合があります。その場合はあらかじめ告示しますが、緊急を要し、やむを得ない場合は、この限りではありません。
                                </p>
                            </div>

                            <h3 className="mod-hdg-l3-02">
                                <span>ご登録について</span>
                            </h3>

                            <div className="mod-list">
                                <ul className="list">
                                    <li>
                                        <div className="mod-txt">
                                            <p>当システムの利用にはPartner's BridgeまたはDWPのアカウント登録が必要です。</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="mod-txt">
                                            <p>ご登録いただいた個人情報の確認・訂正は、登録者本人が行ってください。</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="mod-txt">
                                            <p>アカウント登録に利用したメールアドレスが変更された場合、過去の問い合わせ履歴を参照することが出来なくなります。</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>

                            <div className="mod-btn of-no-arrow">
                                <div className="btn">
                                    <button onClick={() => { window.close() }}>
                                        閉じる
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
            </main>
        </>
    );
}


export default MainComponent;